import { useEffect, useState } from 'react';
import type { NavItem } from '../../../types/proposal-content';

interface ProposalSidebarRightProps {
  sections: NavItem[];
}

export function ProposalSidebarRight({ sections }: ProposalSidebarRightProps) {
  const [activeId, setActiveId] = useState<string>('');

  useEffect(() => {
    if (sections.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        }
      },
      { rootMargin: '-80px 0px -60% 0px', threshold: 0 }
    );

    sections.forEach((s) => {
      const el = document.getElementById(s.id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [sections]);

  if (sections.length === 0) return null;

  return (
    <aside className="w-p-onpage shrink-0 sticky top-[56px] h-[calc(100vh-56px)] overflow-y-auto py-8 px-4 hidden lg:block">
      <div className="text-[11px] font-semibold text-proposal-fg3 uppercase tracking-wider mb-2.5">
        En esta página
      </div>
      {sections.map((s) => (
        <a
          key={s.id}
          href={`#${s.id}`}
          onClick={(e) => {
            e.preventDefault();
            const el = document.getElementById(s.id);
            if (el) {
              const top = el.getBoundingClientRect().top + window.scrollY - 80;
              window.scrollTo({ top, behavior: 'smooth' });
            }
          }}
          className={`block text-[12px] py-1 pl-3 border-l-2 mb-0.5 transition-colors ${
            activeId === s.id
              ? 'text-proposal-accent border-l-proposal-accent'
              : 'text-proposal-fg3 border-l-proposal-border hover:text-proposal-fg1 hover:border-l-proposal-border-strong'
          }`}
        >
          {s.label}
        </a>
      ))}
    </aside>
  );
}
